import React, { FC } from 'react';
import cx from 'classnames';

import { config } from 'data';
import { useLang } from 'hooks';
import { World } from 'components/icons';
import { Select } from 'components/ui';
import { SelectProps } from 'types/components';

import styles from './styles.module.css';

type LanguageSelectProps = Omit<SelectProps, 'value' | 'options' | 'prefix' | 'loading' | 'onChange'>;

const LanguageSelect: FC<LanguageSelectProps> = ({ className, ...props }) => {
  const lang = useLang();

  return (
    <Select
      className={cx(styles.root, className)}
      placeholder={lang.get('common.form.language.placeholder')}
      value={lang.locale}
      options={config.LOCALES.map((locale) => ({
        value: locale,
        label: lang.get(`common.languages.${locale}`),
      }))}
      prefix={<World />}
      onChange={lang.changeLocale}
      {...props}
    />
  );
};

export default LanguageSelect;
